const moduleOptions = `{"generateRoutes":true,"route":"compare","enabled":true}`;
var plugin_default = (context, inject) => {
  const options = JSON.parse(moduleOptions);
  let wm = context.$wm || {};
  wm.compare = options;
  inject("wm", wm);
};
export {
  plugin_default as default
};
